import script from "./Reemplazos_Fuera_Servicio_Historico.vue?vue&type=script&setup=true&lang=js"
export * from "./Reemplazos_Fuera_Servicio_Historico.vue?vue&type=script&setup=true&lang=js"

import "./Reemplazos_Fuera_Servicio_Historico.vue?vue&type=style&index=0&id=ee7ddd7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee7ddd7c"]])

export default __exports__